import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TakeTest from "./TakeTest";
import {getLevelQuestionssByRoleAndLevel,submitAssessmentTest} from "../../../services/redux/Training/action";

const mapStateToProps = (state) => ({
    levelQuestions: state.Training.assesmentQuestions
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLevelQuestionssByRoleAndLevel,
            submitAssessmentTest
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(TakeTest);